import { z } from "zod"

export const SalesOrderFulfilmentModelSchema = z.object({})

/**
 * Future model when we start receiving fulfilment information
 */
export type SalesOrderFulfilmentModel = z.infer<typeof SalesOrderFulfilmentModelSchema>
